import { Component, OnInit } from '@angular/core';
import { isLanguageJapanese } from '@app-shared/config/language';

@Component({
  selector: 'lib-user-reached-day-apply-limit-page',
  templateUrl: './user-reached-day-apply-limit-page.component.html',
  styleUrls: ['./user-reached-day-apply-limit-page.component.scss']
})
export class UserReachedDayApplyLimitPageComponent implements OnInit {
  isLanguageJapanese = isLanguageJapanese();

  constructor() {
  }

  ngOnInit(): void {
  }

}
